import { render, staticRenderFns } from "./form_leave.vue?vue&type=template&id=cd04c1dc&scoped=true&"
import script from "./form_leave.vue?vue&type=script&lang=js&"
export * from "./form_leave.vue?vue&type=script&lang=js&"
import style0 from "./form_leave.vue?vue&type=style&index=0&id=cd04c1dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd04c1dc",
  null
  
)

export default component.exports